// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"card-image-type-2-m__wrapper__3U9kE","qt-figure":"card-image-type-2-m__qt-figure__2YCvs","image":"card-image-type-2-m__image__24jY9"};